<template>
  <div class="my-2 menu-200-menu-item">

    <div class="accordion cursor-pointer" v-if="item.children != null && item.children.length > 0"
         :id="`accordion_${generateHashOfAccordion}`">
      <div class="my-3" >
        <div class=" px-0 text-center" :id="`headingOne${item.id}`">

          <div data-toggle="collapse"
               :data-target="`#collapseOne${item.id}`" aria-expanded="true"
               :aria-controls="`collapseOne${item.id}`" class="d-flex justify-content-between ">
            <span>{{ item.name }}</span>
            <span>
              <i class="bi bi-caret-down-fill"></i>
            </span>
          </div>


        </div>

        <div v-for="collapse in item.children" :id="`collapseOne${item.id}`" class="collapse" :aria-labelledby="`headingOne${item.id}`"
             :data-parent="`#accordion_${generateHashOfAccordion}`">
          <div class="py-2 px-1">

            <menu-item :item="collapse"/>

          </div>
        </div>
      </div>
    </div>

    <div class="text-right" v-else>
      <m-a :href="item.url" target="_blank">
        <m-menu-icon-manager :itemIcon="item.icon_class"/>
        <span class="menu-item-content">{{ item.name }}</span>
      </m-a>
    </div>
  </div>
</template>

<script>
import mA from '../../Tags/A.vue'
import {generateHash} from "@moeinmdn/mixitweb-front-modules/src/plugin/Modules/ShoppingCart";
import mMenuIconManager from "../../Menu/MenuIconManager.vue";

export default {
  name: "MenuItem",
  components: {mMenuIconManager, mA},
  props: {
    item: {}
  },
  computed: {
    generateHashOfAccordion() {
      return this.generateHash()
    }
  },
  methods: {
    generateHash
  }

}
</script>

<style scoped>
.cursor-pointer {
  cursor: pointer;
}

.menu-item-content {
  color: black;
  font-weight: normal;
  font-size: 12px;
}

</style>